import { axios } from '@Root/API'

export const getAll = params => {
	return axios.get('students/course-session', { params })
}
